import {TFunction} from 'i18next';

const AFFECTED_PLANS_NAMES_LIMIT = 10;

export const formatAffectedPlansMessage = (
    t: TFunction,
    affectedCount: number,
    affectedPlanNames?: string[],
    moreAffectedPlansCount?: number
): string => {
    if(affectedCount <= 0) {
        return '';
    }

    const baseMessage = t('priceGroupChangeImpact', {count: affectedCount});
    const names = (affectedPlanNames || []).filter(Boolean);

    if(names.length === 0) {
        return baseMessage;
    }

    const moreCount = moreAffectedPlansCount ?? Math.max(0, affectedCount - AFFECTED_PLANS_NAMES_LIMIT);
    const namesText = names.join(', ');
    const moreText = moreCount > 0 ? ` ${t('andMoreAffectedPlans', {count: moreCount})}` : '';

    return `${baseMessage}: ${namesText}${moreText}`;
};
